import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const dotVariants = cva('inline-block rounded-full shrink-0', {
  variants: {
    variant: {
      ok:   'bg-(--color-green)',
      warn: 'bg-(--color-amber)',
      crit: 'bg-(--color-red)',
      info: 'bg-(--color-blue)',
      muted:'bg-(--color-text3)',
    },
    size: {
      xs: 'size-1.5',
      sm: 'size-2',
      md: 'size-2.5',
      lg: 'size-3',
    },
    pulse: {
      true: 'animate-[pulse-dot_2s_ease-in-out_infinite]',
      false: '',
    },
  },
  defaultVariants: { variant: 'ok', size: 'sm', pulse: false },
});

interface DotProps extends VariantProps<typeof dotVariants> {
  className?: string;
}

export function Dot({ variant, size, pulse, className }: DotProps) {
  return <span className={cn(dotVariants({ variant, size, pulse, className }))} />;
}
